import { Component, Injectable, OnInit, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import {
  ActivatedRoute
} from "@angular/router";
import * as moment from "moment";
import { LmsService } from "../../_Lms/services/lms.service";
import { DataSharingService } from "../../AuthGuard/DataSharingService";
import { MasterService } from "../../Shared/app.Masters.Service";
import { SnackbarComponent } from "../../snackbar/snackbar.component";
import { ReportsService } from "../services/reports.service";
declare var $: any;
// Excel export code start here
import { CommonFunctions } from "../../CommonComponent/function/commonfunctions";
import { Router } from "@angular/router";
import * as FileSaver from "file-saver";
import { LosService } from "src/app/_LOS/services/los.service";
import * as XLSX from "xlsx";
const EXCEL_TYPE =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const EXCEL_EXTENSION = ".xlsx";
// Excel export code end here

@Component({
    selector: "app-booking-list",
    templateUrl: "./booking-list.component.html",
    styleUrls: ["./booking-list.component.scss"],
    standalone: false
})
export class BookingListComponent implements OnInit {
  currentUser: any;
  showSpinner: boolean = false;
  div_list: boolean = false;
  pageTitle: any = "Booking List";
  BranchesList: any = [];
  DataSource: any = [];
  DataSourceModel: any;
  ModelTitle: any;
  displayedColumnsModel: string[];
  Collateral: any;
  Collateral_Type: any;
  Info: any;
  dataviewAssetItemSource: any;
  dataAssetItemSource: any;
  ItemArr: any = [];
  displayedViewAssetItemColumns: any;

  selectedId: any;

  configSuccess: MatSnackBarConfig = {
    panelClass: "style-success",
    duration: 5000,
    horizontalPosition: "right",
    verticalPosition: "top",
  };

  displayedColumns: string[];

  //Form value
  FromDate: any = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
  ToDate: any = new Date();

  FyearId: any;
  maxDate: any;
  minDate: any;

  JsonData: any[] = [];

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild("paginatorlist", { read: MatPaginator, static: true })
  paginatorlist: MatPaginator;
  SelectSourceType: any = "";
  // partnerDropdown: any;
  sourceNameDropdownSettings = {
    singleSelection: false,
    idField: "PartnerId",
    textField: "Partner_Name",
    selectAllText: "Select All",
    unSelectAllText: "Deselect All",
    itemsShowLimit: 1,
    allowSearchFilter: true,
    closeDropDownOnSelection: false,
    showSelectedAllText: true,
    maxHeight: 190,
    searchPlaceholderText: "Search Source Name",
    showSelectedItemsAtTop: true,
  };
  partnerDropdown: any[] = []
  SalesExecutiveData: any = [];
  // LeadSourceName: any;
  leadSourceDropdown: any;
  LeadSourceName: any[] = [];
    LoanAccountCategory: any[] = [];
  catgegoryIdList: any = [];
    categoryDropdownSettings: any = {};
  IsPatnerColumnAllow: number = 0;




  constructor(
    private router: Router,
    private dataSharingService: DataSharingService,
    private reportsService: ReportsService,
    private MasterService: MasterService,

    private snackBar: MatSnackBar,
    private lmsService: LmsService,
    private route: ActivatedRoute,
    private losService: LosService,
    private commonFunctions: CommonFunctions
  ) {
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
  }

  ngOnInit() {
    this.dataSharingService.HeaderTitle.next(this.pageTitle);
    // this.Get_PartnerForDropdown();
    this.getLeadSourceDropdown();
    this.GetSalesExecutive();
        this.Get_Loan_Accounting_Category_ForDropdown();
    this.initializeCategoryDropdownSettings();


    this.displayedViewAssetItemColumns = [
      "Id",
      "ItemName",
      "ItemType",
      "Qty",
      "PurityCT",
      "GrossWt",
      "StoneWt",
      "OtherWt",
      "ValulationRate_PerCT",
      "ValulationAmount",
    ];

    this.route.queryParams.subscribe((params) => {
      this.FyearId = params["fyear"];
      //console.log("paran", this.FyearId);
      this.lmsService
        .Get_FinancialYear({ Id: this.FyearId })
        .subscribe((res: any) => {
          this.minDate = new Date(moment(res[0].fystart).format("MM/DD/YYYY"));
          this.maxDate = new Date(moment(res[0].fyent).format("MM/DD/YYYY"));
          this.FromDate = new Date(moment(res[0].fystart).format("MM/DD/YYYY"));
          if (this.maxDate > new Date() && this.minDate < new Date())
            this.ToDate = new Date();
          else this.ToDate = this.maxDate;
          this.DataSource = null;
        });
    });
    this.displayedColumns = [
      "Id",
      "Application_No",
      "Application_Date",
      "LoanAcNo",
      "Loan_Date",
      "Loan_Acc_Category",
      "CustomerName",
      "Customer_PhoneNo",
      "AC_Customer_Age",
      "Address",
      "LatLong",
      "Co",
      "Co_name",
      "Co_Borrower",
      "Co_Borrower_Age",
      "Co_Borrower_Relation",
      "Co_Borrower_PhoneNo",
      "Co_BorrowerAddress",
      "Guarantor",
      "Guarantor_Age",
      "Guarantor_Relation",
      "Guarantor_PhoneNo",
      "GuarantorAddress",
      "LoanSegment",
      "LoanAmount",
      "Required_Amount",
      "Application_InterestAmt",
      "Application_AgreementValue",
      "Application_LoanEMIAmount",
      "No_of_EMI",
      "Application_LoanTenure",
      "LTV",
      "ROI",
      "Application_Case_IRR",
      "Application_Disbursement_IRR",
      "Due_Date",
      "Application_ExpiryDate",
      "LoanClosed_Date",
      "Application_AdvInstl",
      "EMI_Frexvency",
      "No_of_Ref",
      "Primary_Assets_Type",
      "Additional_Assets_Type",
      "SourceType",
      "PartnerCode",
      "SourceName",
      "Product_Name",
      "Branch_Name",
      "SourceArea",
      "SalesExecutive",
      "SalesEmp_Code",
      "CollectionExecutive",
      "ColEmp_Code",
      "CollectionArea",
      "CollectionSubarea",
      "SPDC_Bank",
      "SPDC_Cheque",
      "RPDC_Bank",
      "RPDC_Cheque",
      "Application_LoanPurpose",
      "EMI_Structure",
    ];

  }
  Get_Loan_Accounting_Category_ForDropdown() {
    this.lmsService
      .Get_Loan_Accounting_Category_ForDropdown({ ProductId: 0 })
      .subscribe((res: any) => {
        this.catgegoryIdList = res;
      });
  }
  onCategorySelectionChange() {
    this.catgegoryIdList = this.moveSelectedItemsToTop(
      this.catgegoryIdList,
      this.LoanAccountCategory,
      "Loan_CategoryId"
    );
   }
   getSelectedIds(items: any[], key: string): string {
    return items?.map((item) => item[key]).join(",") || "0";
  }
  initializeCategoryDropdownSettings() {
    this.categoryDropdownSettings = {
      singleSelection: false,
      idField: "Loan_CategoryId",
      textField: "Loan_category",
      selectAllText: "Select All",
      unSelectAllText: "Deselect All",
      allowSearchFilter: true,
      itemsShowLimit: 1,
      showSelectedItemsAtTop: true,
    };
  }

  onSearchBusinessData() {
    this.showSpinner = true;

    this.reportsService
      .Report_Booking_List({
        From: this.FromDate,
        To: this.ToDate,
        LoanAcId: "",
        LoginUserId: this.currentUser.userId,
        SourceType: this.SelectSourceType || "",
        // SourceId: this.LeadSourceName || 0,
        SourceId: this.LeadSourceName.length > 0
          ? this.LeadSourceName.map((x: any) => x.PartnerId).join(',')
          : '0',
        LoanAcCategory: this.LoanAccountCategory?.length > 0 ? this.getSelectedIds(this.LoanAccountCategory, "Loan_CategoryId") : "0",

      })
      .subscribe((res: any) => {
        console.log(res);
        if (res.length > 0) {
          this.IsPatnerColumnAllow = res[0].IsPatnerColumnAllow;
          this.buildDisplayedColumns();
          const processed = this.preserveWhitespace(res);
          this.JsonData = JSON.parse(JSON.stringify(processed));
          this.DataSource = new MatTableDataSource(
            JSON.parse(JSON.stringify(processed))
          );
          this.DataSource.filterPredicate = (data: any, filter: string) => {
            if (!filter) return true;
            const searchTerm = filter.replace(/\s+/g, ' ').trim();
            return Object.keys(data).some(key => {
              const cellValue = String(data[key] || '')
                .toLowerCase()
                .replace(/\u00A0/g, ' ')
                .replace(/\s+/g, ' ')
                .trim();
              return cellValue.includes(searchTerm);
            });
          };
          this.DataSource.sort = this.sort;
          this.DataSource.paginator = this.paginator;
          this.showSpinner = false;
          this.div_list = true;
        } else {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: "No data found",
            ...this.configSuccess,
          });
          this.showSpinner = false;
          this.div_list = false;
          this.DataSource = null;
        }
      });
  }

  DateChange() {
    if (this.FromDate != "" && this.ToDate != "") {
      if (this.FromDate > this.ToDate) {
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: "To Date will be greater than to From Date.",
          ...this.configSuccess,
        });
        this.FromDate = "";
        this.ToDate = "";
      }
    }
  }

  onClickCustomerRefData(row) {
    this.displayedColumnsModel = [
      "Id",
      "ReferenceType",
      "Name",
      "ContactNo",
      "Customer",
      "KnowYear",
      "Address",
      "CreatedOn",
    ];
    this.ModelTitle = "Customer Reference";
    this.paginatorlist.pageIndex = 0;
    this.lmsService
      .LMS_GetCustomerRef({ Loan_Id: row.Loan_Id })
      .subscribe((res: any) => {
        //console.log("res : ", res);
        if (res.length > 0) {
          this.DataSourceModel = new MatTableDataSource(
            JSON.parse(JSON.stringify(res))
          );
          this.DataSourceModel.sort = this.sort;
          this.DataSourceModel.paginator = this.paginatorlist;
          this.showSpinner = false;

          $("#ViewCustomerChqAssetDetails").modal("show");
          $("#ViewCustomerChqAssetDetails").css("z-index", "1050");
        }
      });
  }

  applyFilter(filterValue: string) {
    this.DataSource.filter = filterValue.trim().toLowerCase();
  }

  buildDisplayedColumns() {
    this.displayedColumns = [
      "Id",
      "Application_No",
      "Application_Date",
      "LoanAcNo",
      "Loan_Date",
      "Loan_Acc_Category",
      "CustomerName",
      "Customer_PhoneNo",
      "AC_Customer_Age",
      "Address",
      "LatLong",
      "Co",
      "Co_name",
      "Co_Borrower",
      "Co_Borrower_Age",
      "Co_Borrower_Relation",
      "Co_Borrower_PhoneNo",
      "Co_BorrowerAddress",
      "Guarantor",
      "Guarantor_Age",
      "Guarantor_Relation",
      "Guarantor_PhoneNo",
      "GuarantorAddress",
      "LoanSegment",
      "LoanAmount",
      "Required_Amount",
      "Application_InterestAmt",
      "Application_AgreementValue",
      "Application_LoanEMIAmount",
      "No_of_EMI",
      "Application_LoanTenure",
      "LTV",
      "ROI",
      "Application_Case_IRR",
      "Application_Disbursement_IRR",
      "Due_Date",
      "Application_ExpiryDate",
      "LoanClosed_Date",
      "Application_AdvInstl",
      "EMI_Frexvency",
      "No_of_Ref",
      "Primary_Assets_Type",
      "Additional_Assets_Type",
      "SourceType",
      "PartnerCode",
      "SourceName",
      "Product_Name",
      "Branch_Name",
      "SourceArea",
      "SalesExecutive",
      "SalesEmp_Code",
      "CollectionExecutive",
      "ColEmp_Code",
      "CollectionArea",
      "CollectionSubarea",
      "SPDC_Bank",
      "SPDC_Cheque",
      "RPDC_Bank",
      "RPDC_Cheque",
      "Application_LoanPurpose",
      "EMI_Structure",
    ];
    if (this.IsPatnerColumnAllow == 1) {
      const idx = this.displayedColumns.indexOf("LoanAcNo");
      this.displayedColumns.splice(idx + 1, 0, "PLoanAcNo");
    }
  }

  preserveWhitespace(data: any[]): any[] {
    return data.map(row => {
      const newRow = { ...row };
      Object.keys(newRow).forEach(key => {
        if (typeof newRow[key] === 'string' && newRow[key].match(/ {2,}/)) {
          newRow[key] = newRow[key].replace(/ {2,}/g, m => '\u00A0'.repeat(m.length));
        }
      });
      return newRow;
    });
  }
  onClickChequeData(row, type) {
    let chqType;
    this.displayedColumnsModel = [
      "Id",
      "PdcType",
      "CustomerName",
      "Bankname",
      "Branch",
      "AccType",
      "Ac",
      "ChFrom",
      "ChTo",
      "NoOfChqs",
      "IFSCCode",
    ];

    if (type == 1) {
      this.ModelTitle = "SPDC Cheque Reference";
      chqType = "SPDC";
    } else {
      this.ModelTitle = "RPDC Cheque Reference";
      chqType = "RPDC";
    }
    this.paginatorlist.pageIndex = 0;
    this.lmsService
      .GetChequeDetails({ Loan_Id: row.Loan_Id, Type: chqType })
      .subscribe((res: any) => {
        console.log("SPDC : ", res);
        if (res.length > 0) {
          this.DataSourceModel = new MatTableDataSource(
            JSON.parse(JSON.stringify(res))
          );
          this.DataSourceModel.sort = this.sort;
          this.DataSourceModel.paginator = this.paginatorlist;
          this.showSpinner = false;

          $("#ViewCustomerChqAssetDetails").modal("show");
          $("#ViewCustomerChqAssetDetails").css("z-index", "1050");
        }
      });
  }
  onClickAssetsData(row, type) {
    let AssetType;
    this.displayedColumnsModel = [
      "Id",
      "Collateral_Type",
      "Collateral",
      "ValuationType",
      "ValuationAmount",
      "ValuationDate",
      "View_Detail",
    ];

    if (type == 1) {
      this.ModelTitle = " Primary Assets Type Details";
      AssetType = "Primary";
    } else {
      this.ModelTitle = " Additional Assets Type Details";
      AssetType = "Additional";
    }
    this.paginatorlist.pageIndex = 0;
    this.lmsService
      .LMS_GetAllUserAssetInfo({ Loan_Id: row.Loan_Id, Type: AssetType })
      .subscribe((res: any) => {
        console.log("res : ", res);
        if (res.length > 0) {
          this.DataSourceModel = new MatTableDataSource(
            JSON.parse(JSON.stringify(res))
          );
          this.DataSourceModel.sort = this.sort;
          this.DataSourceModel.paginator = this.paginatorlist;
          this.showSpinner = false;

          $("#ViewCustomerChqAssetDetails").modal("show");
          $("#ViewCustomerChqAssetDetails").css("z-index", "1050");
        }
      });
  }

  onCloseBookingList() {
    $("#ViewCustomerChqAssetDetails").modal("hide");
  }

  ViewData(row) {
    this.lmsService
      .ViewAssetInfo({ SearchBy: row.Collateral, Id: row.AssetId })
      .subscribe((response: any) => {
        this.Collateral = row.Collateral;
        this.Collateral_Type = row.Collateral_Type;
        this.Info = response.Item1[0];
        if (this.Collateral == "Gold") {
          this.dataviewAssetItemSource = new MatTableDataSource(response.Item2);
          this.dataAssetItemSource = new MatTableDataSource(response.Item2);
          this.ItemArr = response.Item2;
        }
        $("#View").modal("show");
        $("#View").css("z-index", "1050");
      });
  }
  onCloseView() {
    $("#View").modal("hide");
  }

  public highlightRow(row) {
    this.selectedId = row.Loan_Id;
  }

  totaltypewise(type) {
    if (
      this.DataSource != null &&
      this.DataSource != undefined &&
      this.DataSource != ""
    ) {
      let sum = 0;
      for (let i = 0; i < this.DataSource.filteredData.length; i++) {
        sum += Number(this.DataSource.filteredData[i][type]);
      }
      return sum > 0 ? sum.toFixed(2) : 0;
    }
    return 0;
  }

  // Excel export in backend start here
  public exportAsExcelFile(json: any[], excelFileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const workbook: XLSX.WorkBook = {
      Sheets: { data: worksheet },
      SheetNames: ["data"],
    };
    const excelBuffer: any = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const data: Blob = new Blob([excelBuffer], { type: EXCEL_TYPE });
    FileSaver.saveAs(
      data,
      excelFileName + new Date().getTime() + EXCEL_EXTENSION
    );
  }

  exportexcelNew(): void {
    const fromDateStr = moment(this.FromDate).format("DD-MM-YYYY");
    const toDateStr = moment(this.ToDate).format("DD-MM-YYYY");
    const worksheetName = "BOOKING LIST";
    const headerRow = `<tr>
      <th colspan="${this.displayedColumns.length}" style="font-size: 16px; font-weight: bold; text-align: center; border: 1px solid white;">
        Booking List ( ${moment(this.FromDate).format("DD/MM/YYYY")} - ${moment(this.ToDate).format("DD/MM/YYYY")} )
      </th>
    </tr>`;

    this.commonFunctions.exportHtmlTableToExcel(
      "booking_list",
      `${worksheetName}_${fromDateStr}_To_${toDateStr}.xls`,
      worksheetName,
      headerRow
    );
  }
  exportTable() { }

  getLeadSourceDropdown() {
    this.showSpinner = true;
    this.losService.getLeadSourceDropdown({}).subscribe((res: any) => {
      this.leadSourceDropdown = res;
      console.log("Lead Source Dropdown", this.leadSourceDropdown);
      this.showSpinner = false;
    });
  }

  moveSelectedItemsToTop(items: any[], selectedItems: any[], key: string): any[] {
    if (!items?.length) return [];
    if (!selectedItems?.length) return items;

    const selectedIds = selectedItems.map((s) => s[key]);
    const selected = items.filter((i) => selectedIds.includes(i[key]));
    const rest = items.filter((i) => !selectedIds.includes(i[key]));
    return [...selected, ...rest];
  }

  onSourceNameSelectionChange() {
    this.partnerDropdown = this.moveSelectedItemsToTop(
      this.partnerDropdown,
      this.LeadSourceName,
      "PartnerId"
    );
  }

  Get_PartnerForDropdown(sourceType: any) {
    console.log("Partner Dropdown API Function");
    this.SelectSourceType = sourceType ?? this.SelectSourceType; // change by codex: use the latest selected source type on first selection.

    if (
      this.SelectSourceType == "Agent" ||
      this.SelectSourceType == "DSA" ||
      this.SelectSourceType == "Dealer"
    ) {
      this.losService
        .Get_PartnerForDropdown({
          PartnerType: this.SelectSourceType,
          branchId: 0,
        })

        .subscribe((res: any) => {
          this.partnerDropdown = res;
        });
      this.LeadSourceName = [];
    } else if (
      this.SelectSourceType == "Sales Executive" ||
      this.SelectSourceType == "Telecaller Executive" ||
      this.SelectSourceType == "Marketing Executive"
    ) {
      this.partnerDropdown = [];
      this.showSpinner = true;
      this.SalesExecutiveData.forEach((obj: any) => {
        this.partnerDropdown.push({
          PartnerId: obj.EmpId,
          Partner_Name: obj.EmpName,
        });
      });
      console.log("Partner Dropdown vla data ", this.partnerDropdown);
      this.showSpinner = false;
      // this.LeadSourceName = [];
    } else {
      this.LeadSourceName = [];
    }
  }

  GetSalesExecutive() {
    this.losService
      .getEmployeeDropdown({
        BranchId: 0,
        ProcessId: 1,
        ProductId: 0,
      })
      .subscribe((res: any) => {
        // this.employeeDropdown = res;
        this.SalesExecutiveData = res;
        this.Get_PartnerForDropdown(this.SelectSourceType);
        //console.log('res', res);
      });
  }
}
